import { Divider, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useApplicationStore } from "../../context/ApplicationStoreContext";

const CustomerConfirmCard = () =>{
  const { state } = useApplicationStore();

  return (
    <Paper variant="outlined">
      <Grid p={1}>
        <Stack spacing={0.3}>
          <Typography variant="caption">お客さま情報</Typography>
          <Divider />
          <Typography variant="body2">氏名:{state.customer?.name}</Typography>
          <Typography variant="body2">
            メールアドレス:{state.customer?.email}
          </Typography>
          <Typography variant="body2">
            携帯電話番号:{state.customer?.phone}
          </Typography>
          <Typography variant="body2">
            お届先郵便番号:{state.customer?.address[0]?.postal_code}
          </Typography>
          <Typography variant="body2">
            お届先住所:
            {state.customer?.address[0]?.pref! +
              state.customer?.address[0]?.city! +
              state.customer?.address[0]?.town! +
              state.customer?.address[0]?.address1 +' '+
              state.customer?.address[0]?.address2}
          </Typography>
        </Stack>
      </Grid>
    </Paper>
  );
}


export default CustomerConfirmCard;


